export default {
  getPublicKey(state) {
    return state.publicKeyData;
  },
  getData(state) {
    return state.data;
  },
  isFetching(state) {
    return state.isFetching;
  },
  getRequestStatus(state) {
    return state.requestStatus;
  },
  getOtpData(state) {
    return state.otpData;
  },

  getSavedPayload(state) {
    return state.savedPayload;
  },

  getRegisterMobileData(state) {
    return state.regMobileData;
  },

  getMyInfoDetails(state) {
    return state.myInfoDetails;
  },

  isMobileNumberUpdated(state) {
    return state.isMobileNumberUpdated;
  },

  getMemberId(state) {
    return state.memberId;
  },

  getExistingMemberId(state) {
    return state.existingMemberId;
  },
  getCurrentStep(state) {
    return state.currentStep;
  },
  getStepperMaxLength(state) {
    return state.stepperMaxLength;
  },
  getSignUpMobile(state) {
    return state.signUpMobile;
  },
};
